/* @flow */
import { push, goBack } from 'react-router-redux';
import ObjectID from 'bson-objectid';
import qs from 'qs';
import { pickBy, identity } from 'lodash/fp';

import l from '../../utils/localization';
import { logEvent } from '../../utils/analytics';


export const gotoLater = () => (dispatch: Dispatch) => dispatch(push('/later'));

export const gotoToDo = () => (dispatch: Dispatch) => dispatch(push('/todo'));

export const gotoDone = () => (dispatch: Dispatch) => dispatch(push('/profile/done'));

export const gotoProfile = () => (dispatch: Dispatch) => dispatch(push('/profile'));

export const navigateBack = () => (dispatch: Dispatch) => dispatch(goBack());

export const openItemDetails = (itemId: string, recurringId: string) => (dispatch: Dispatch, getState: () => Object) => {
  const { pathname } = getState().routing.locationBeforeTransitions;
  const itemPart = `itemId=${itemId}`,
        recurringPart = recurringId ? `&recurringId=${recurringId}` : '';
  dispatch(push(`${pathname}?${itemPart}${recurringPart}`));
};

export const handleSessionExpiry = () => (dispatch: Dispatch) => {
  if (window.location.href.indexOf('login') === -1) {
    window.alert(
      l.sessionExpired,
    );

    dispatch(push(`/profile`));
  }
};

export const closeItemDetails = () => (dispatch: Dispatch, getState: () => Object) => {
  const { pathname } = getState().routing.locationBeforeTransitions;
  dispatch(push(`${pathname}`));
};

export const navigateToItem = ({
  id, recurring, postponedUntil, status,
}: TodoItem = {}) => (
  dispatch: Dispatch, getState: () => Object,
) => {
  const { pathname } = getState().routing.locationBeforeTransitions,
        itemId = id || ObjectID().toString(),
        queryPart = qs.stringify(pickBy(identity, {
          itemId, recurringId: recurring && recurring.id, postponedUntil, status,
        }));

  logEvent(id ? 'todo_opening' : 'todo_adding');

  dispatch(push(`${pathname}?${queryPart}`));
};
